import RecipientMessagesManagementList from "../pages/Management";
import RecipientMessagesCompaniesList from "../pages/Companies";
import RecipientMessagesEstablishmentsList from "../pages/Establishments";

export const defaultTabs = () => [
  {
    label: 'Gestão',
    value: '',
    body: <RecipientMessagesManagementList />,
  },
  {
    label: 'Empresas',
    value: 'companies',
    body: <RecipientMessagesCompaniesList />,
  },
  {
    label: 'Estabelecimentos',
    value: 'establishments',
    body: <RecipientMessagesEstablishmentsList />,
  }
]
